// import { io } from "socket.io-client";
// import { ApiUrl } from "./modules";

// export const socket = io(ApiUrl.replace('/api/v1', ''), {
//   transports: ['websocket'],
//   autoConnect: false
// });
import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "http://localhost:4000";

export const socket = io(SOCKET_URL, {
  autoConnect: false,
});

